import { cancelFocusEntity, deleteCollection, moveToTrash } from "@apis/http/api";
import { useFocusAction } from "@hooks/utils";

const useFocusActionClick = () => {
  const { cancelFocusSuccess } = useFocusAction();

  const cancelFocus = async (entityId: string, focusType: string) => {
    if (["video", "script"].includes(focusType)) {
      await deleteCollection({ id: entityId } as any);
    } else if (focusType === "video-generation") {
      await moveToTrash({ id: entityId } as any);
    } else if (focusType === "product") {
      await cancelFocusEntity({
        entityId,
        groupType: focusType.toUpperCase(),
      } as any);
    }
    cancelFocusSuccess(focusType);
  };

  return { cancelFocus };
};

export { useFocusActionClick };
